module.exports = __webpack_public_path__ + "static/media/mt-icone-encart-5.f5231d30.svg";